import { IsString, IsDateString, IsEnum } from "class-validator";
import { Expose } from "class-transformer";
import { MIGRATION_TYPE_ENUM } from "@/static/migrationTypeEnum";

export class MigrationItem {
  @IsDateString()
  @Expose()
  date!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  fullName!: string;
  @IsEnum(MIGRATION_TYPE_ENUM)
  @Expose()
  type!: MIGRATION_TYPE_ENUM;
  @IsString()
  @Expose()
  previousFullName!: string;
}
